import ApolloLinkTimeout from 'apollo-link-timeout'

const timeoutLink = new ApolloLinkTimeout(10000) // 10 second timeout

export default timeoutLink
